module.exports = __webpack_public_path__ + "jquery-ui.600382db833dd0c9ade2.woff";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/fonts/jquery-ui.woff?uyccen
// module id = ../../../../../client/assets/fonts/jquery-ui.woff?uyccen
// module chunks = styles